const IMAGE_HEIGHT = 360;

const getImageUrlFromList = ({ images, height = IMAGE_HEIGHT }) =>
  images.find(image => image.height === height)?.source;

export { getImageUrlFromList };
